import { render, staticRenderFns } from "./WithdrawView.vue?vue&type=template&id=54dfba50&scoped=true"
import script from "./WithdrawView.vue?vue&type=script&lang=js"
export * from "./WithdrawView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfba50",
  null
  
)

export default component.exports